"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelSelector = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/overlay/select/select");
const MODEL_OPTIONS = [
    { value: 'claude-opus', label: 'Claude Opus' },
    { value: 'claude-sonnet', label: 'Claude Sonnet' },
    { value: 'claude-haiku', label: 'Claude Haiku' },
];
let ModelSelector = class ModelSelector extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.value = 'claude-sonnet';
    }
    render() {
        return (0, lit_1.html) `
      <mm-select
        aria-label="모델"
        .value=${this.value}
        .options=${MODEL_OPTIONS}
        placement="top-start"
        @change=${this.handleSelectChange}
      ></mm-select>
    `;
    }
    // select가 트리거 라벨을 스스로 소유하므로, 여기서는 외부에 노출하는 value 프로퍼티만 동기화한다.
    handleSelectChange(event) {
        this.value = event.detail.value;
    }
};
ModelSelector.styles = (0, lit_1.css) `
    :host {
      display: inline-flex;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ModelSelector.prototype, "value", void 0);
ModelSelector = __decorate([
    (0, decorators_js_1.customElement)('mm-model-selector')
], ModelSelector);
exports.ModelSelector = ModelSelector;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9kZWwtc2VsZWN0b3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJtb2RlbC1zZWxlY3Rvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQTJEO0FBSTNELDhDQUEyQztBQUUzQyxNQUFNLGFBQWEsR0FBaUI7SUFDbEMsRUFBRSxLQUFLLEVBQUUsYUFBYSxFQUFFLEtBQUssRUFBRSxhQUFhLEVBQUU7SUFDOUMsRUFBRSxLQUFLLEVBQUUsZUFBZSxFQUFFLEtBQUssRUFBRSxlQUFlLEVBQUU7SUFDbEQsRUFBRSxLQUFLLEVBQUUsY0FBYyxFQUFFLEtBQUssRUFBRSxjQUFjLEVBQUU7Q0FDakQsQ0FBQTtBQUdNLElBQU0sYUFBYSxHQUFuQixNQUFNLGFBQWMsU0FBUSxnQkFBVTtJQUF0Qzs7UUFNdUIsVUFBSyxHQUFHLGVBQWUsQ0FBQTtJQWtCckQsQ0FBQztJQWhCQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7O2lCQUdFLElBQUksQ0FBQyxLQUFLO21CQUNSLGFBQWE7O2tCQUVkLElBQUksQ0FBQyxrQkFBa0I7O0tBRXBDLENBQUE7SUFDSCxDQUFDO0lBRUQsOERBQThEO0lBQ3RELGtCQUFrQixDQUFDLEtBQXFDO1FBQzlELElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUE7SUFDakMsQ0FBQzs7QUF0Qk0sb0JBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7OztHQUlsQixDQUFBO0FBQzJCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzs0Q0FBd0I7QUFOeEMsYUFBYTtJQUR6QixJQUFBLDZCQUFhLEVBQUMsbUJBQW1CLENBQUM7R0FDdEIsYUFBYSxDQXdCekI7QUF4Qlksc0NBQWEifQ==